var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticStyle:{"min-height":"100%"},attrs:{"flex":"dir:top"}},[_c('router-view')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }